/**
 * The shell's own user lookup.
 *
 * One caller: resolving the `<id>` in `/admin/users/<id>/roles` to the
 * person's name, so the breadcrumb reads "Home › Admin › Users › Acme
 * Compliance Officer › Roles" rather than the generic "Details" crumb — or,
 * before that fallback existed, the raw internal id title-cased into the
 * trail: "… › 1770226980832 Fqe7h6nje › Roles" (QA ledger ADM-002).
 *
 * Alongside `companies.ts` and for the same reason: the entity-label registry
 * lives in the shell, and admin-ui does not depend on it.
 */
import apiClient from './client';

export interface UserSummary {
  id: string;
  fullName?: string;
  email?: string;
}

export const getUserSummary = async (id: string): Promise<UserSummary> => {
  const response = await apiClient.get<{ success: boolean; data: UserSummary }>(
    `/api/admin/users/${id}`
  );
  return response.data.data;
};
